import NewRenew from './new_renew.vue'
import { createCmpEngine } from '@/utils'

export const openNewRenew = createCmpEngine(NewRenew)
